import React from 'react';
import Autocomplete, { createFilterOptions } from '@material-ui/lab/Autocomplete';
import { TextField, withStyles } from '@material-ui/core';
// import CloseIcon from '@material-ui/icons/Close';
// import AfitdTextField from './AfitdTextField';

// import { withStyles } from '@material-ui/core/styles';
// import cx from 'clsx';
import _size from 'lodash/size';
import _debounce from 'lodash/debounce';
import _isArray from 'lodash/isArray';
import _isNil from 'lodash/isNil';
import _isEmpty from 'lodash/isEmpty';

const styles = theme => ({
    tag: {
        background: '#F0F2F6',
        borderRadius: 4,
        '& .MuiChip-deleteIcon': { color: 'rgba(17, 30, 20, 0.4)' },
    },
    // test inputNotchedOutline border styles
    inputRoot: {
        '&$inputFocused $inputNotchedOutline': {
            borderColor: `${theme.palette.secondary.main} !important`,
        },
    },
    inputFocused: {},
    inputNotchedOutline: {
        borderWidth: '2px',
    },
});

const defaultStyle = { width: '100%', padding: 0, margin: 0 };
const errorStyle = { width: '100%', padding: 0, margin: 0, border: '2px solid red', borderRadius: 6 };
const defaultFilter = createFilterOptions(); //createFilterOptions({ limit: 10 });

const AfitdAutocomplete = props => {
    const {
        classes,
        styles,
        isMulti = false,
        multiple = false,
        style = defaultStyle,
        options,
        filterOptions = defaultFilter,
        isClearable = true,
        disableClearable,
        placeholder: placeholderProp,
        value,
        error,
        onSuggestionsFetchRequested,
        ...otherProps
    } = props;

    // console.log({ options });
    let placeholder = placeholderProp;
    if ((_isArray(value) && !_isEmpty(value)) || (!_isArray(value) && !_isNil(value))) {
        placeholder = '';
    }

    // debounce onSuggestionsFetchRequested() for 500ms so it won't fire until the typing pause/top for half a second
    // const debouncedHandleChangeInput = useCallback(
    //     _debounce(value => {
    //         if (_size(value) >= 2 && onSuggestionsFetchRequested) {
    //             onSuggestionsFetchRequested(value);
    //         } else {
    //             onSuggestionsFetchRequested();
    //         }
    //     }, 500),
    //     [],
    // );
    const debouncedHandleChangeInput = _debounce(value => {
        if (_size(value) >= 2 && onSuggestionsFetchRequested) {
            onSuggestionsFetchRequested(value);
        } else {
            onSuggestionsFetchRequested();
        }
    }, 500);

    // handle the input onchange
    const handleChangeInput = evt => {
        const value = evt.target.value;

        debouncedHandleChangeInput(value);
    };

    const InputProps = {
        classes: {
            root: classes.inputRoot,
            focused: classes.inputFocused,
            notchedOutline: classes.inputNotchedOutline,
        },
    };

    return (
        <Autocomplete
            styles={styles}
            selectOnFocus
            autoHighlight
            // autoSelect
            // filterSelectedOptions
            disableClearable={isClearable === false || disableClearable}
            options={options}
            filterOptions={filterOptions}
            getOptionLabel={option => option.label}
            multiple={isMulti || multiple}
            renderInput={params => {
                const InputPropsParam = params.InputProps;
                const inputPropsParam = params.inputProps;
                return (
                    // <AfitdTextField
                    //     color="secondary"
                    //     placeholder={placeholder}
                    //     {...params}
                    //     error={error}
                    //     onChange={handleChangeInput}
                    //     inputProps={{ ...inputPropsParam, autocomplete: 'new-password' }}
                    // />
                    <TextField
                        color="secondary"
                        variant="outlined"
                        placeholder={placeholder}
                        {...params}
                        error={error}
                        onChange={handleChangeInput}
                        InputProps={{ ...InputPropsParam, ...InputProps, autocomplete: 'new-password' }}
                        inputProps={{ ...inputPropsParam, autocomplete: 'new-password' }}
                    />
                );
            }}
            style={error ? errorStyle : style}
            value={value}
            // components={{ MultiValueRemove: CustomMultiValueRemove }}
            // onInputChange={handleChangeInput}
            // maxMenuHeight={200}
            // menuPortalTarget={document.body}
            // isDisabled={disabled}
            {...otherProps}
        />
    );
};

// export default AfitdAutocomplete;
export default withStyles(styles)(AfitdAutocomplete);
